import { createSlice } from "@reduxjs/toolkit";

const authSlice = createSlice({
  name: "auth",
  initialState: { user: {} },
  reducers: {
    updateUser: (state, action) => {
      state.user = action.payload;
    },
    logout: (state, action) => {
      state.user = {};
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("persist:root:admin");
    },
  },
  extraReducers: () => {},
});

export const { updateUser, logout, updateIsUser } = authSlice.actions;

export default authSlice;
